import { render, staticRenderFns } from "./FooterArabic.vue?vue&type=template&id=2283f3f2&"
import script from "./FooterArabic.vue?vue&type=script&lang=js&"
export * from "./FooterArabic.vue?vue&type=script&lang=js&"
import style0 from "./FooterArabic.vue?vue&type=style&index=0&id=2283f3f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports